import { render, staticRenderFns } from "./DialogMapitRegistration.vue?vue&type=template&id=22381fa4"
import script from "./DialogMapitRegistration.vue?vue&type=script&lang=js"
export * from "./DialogMapitRegistration.vue?vue&type=script&lang=js"
import style0 from "./DialogMapitRegistration.vue?vue&type=style&index=0&id=22381fa4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports